import ApiService from './api';

// Users API service
class UserService {
  // Get all users with filtering
  static async getUsers(params = {}) {
    try {
      const response = await ApiService.get('/users', params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user by ID
  static async getUserById(userId) {
    try {
      const response = await ApiService.get(`/users/${userId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Update user
  static async updateUser(userId, data) {
    try {
      const response = await ApiService.put(`/users/${userId}`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Verify user
  static async verifyUser(userId, verificationData) {
    try {
      const response = await ApiService.post(`/users/${userId}/verify`, verificationData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Toggle user status (active/inactive)
  static async toggleUserStatus(userId) {
    try {
      const response = await ApiService.patch(`/users/${userId}/toggle-status`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Delete user
  static async deleteUser(userId) {
    try {
      const response = await ApiService.delete(`/users/${userId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user statistics
  static async getUserStats(userId) {
    try {
      const response = await ApiService.get(`/users/${userId}/stats`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user activity
  static async getUserActivity(userId, params = {}) {
    try {
      const response = await ApiService.get(`/users/${userId}/activity`, params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Bulk user actions
  static async bulkUserActions(action, userIds, data = {}) {
    try {
      const response = await ApiService.post('/users/bulk-actions', {
        action,
        userIds,
        ...data
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get sellers (users with role 'seller')
  static async getSellers(params = {}) {
    try {
      const response = await ApiService.get('/users', {
        ...params,
        role: 'seller'
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user verification requests
  static async getVerificationRequests(params = {}) {
    try {
      const response = await ApiService.get('/users/verification-requests', params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Upload user avatar
  static async uploadAvatar(userId, file, onProgress) {
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      
      const response = await ApiService.upload(
        `/users/${userId}/avatar`,
        formData,
        onProgress
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user dashboard stats
  static async getUserDashboardStats(period = '30d') {
    try {
      const response = await ApiService.get('/users/dashboard-stats', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user growth analytics
  static async getUserGrowthAnalytics(period = '12m') {
    try {
      const response = await ApiService.get('/users/growth-analytics', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default UserService;